<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yNJBgD/tc-custom/9781937716066.jpg?1731153894180" alt="This image is the cover for the book Natural Running"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Natural Running
      </h1>
      <p class="bookDescription body article font2">
        <p>Natural Running is the middle ground runners have been looking for. By learning to run the barefoot way, while wearing shoes, runners will become more efficient, stronger, and healthier runners. Backed by studies at MIT and Harvard, running form and injury expert Danny Abshire presents the natural running technique, form drills, and an 8-week transition plan that will put runners on the path to faster, more efficient, and healthier running.In Natural Running, Abshire explains how modern running shoes distort the efficient running technique that humans evolved over thousands of years. He reviews the history of running shoes and injuries, making the case for barefoot running but also warning about its dangers. By learning the natural running technique, runners can enjoy both worlds: comfortable feet, knees, and legs and an efficient running form that reduces impact and injuries.Natural Running teaches runners to think about injuries as symptoms of poor running form. Abshire specifies the overuse injuries that are most commonly associated with particular body alignment problems, foot types, and form flaws. Runners will learn how to analyze and identify their own characteristics so they can start down the path to natural running.Abshire explains the natural running technique, describing the posture, arm carriage, cadence, and land-lever-lift foot positioning that mimic the barefoot running style. Using Abshire’s 8-week transition plan and a tool kit of strength and form drills, runners will move from heel striking to a midfoot or forefoot strike.Natural Running is the newest way to run and also the oldest. By discovering how they were meant to run, runners will become more efficient, stronger, and healthier runners.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Danny Abshire, Brian Metzler
      </h2>
      
      <p class="authorDescription body article"><B>Danny Abshire</B> is a veteran running coach and injury expert. He is the cofounder of Newton Running, a startup running shoe manufacturer specializing in shoes that promote an efficient midfoot/forefoot running gait. He has been making advanced footwear for runners and triathletes for more than 20 years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      VeloPress Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?434098df